import React from 'react';
import logo from '../images/logo.svg';
import { ImWhatsapp } from 'react-icons/im';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa'; // Importing Font Awesome icons
import { trans } from "../utils";

const Footer = () => {
    return (
        <footer id='footer' className="bg-black text-white py-12 font-serif">
            <div className='container'>
                <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
                    <div>
                        <h4 className='mb-6 text-3xl font-bold'>{trans('Opening Hours')}</h4>
                        <div className="flex items-center mb-4">
                            <FaClock size={32} color="white" className="me-4" /> {/* Watch icon */}
                            <div>
                                <h5 className='mb-1 text-xl'>{trans('Sunday - Friday')}</h5>
                                <p className='mb-1 text-xl'>{trans('10:00 AM - 06:00 PM')}</p>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <FaClock size={32} color="white" className="me-4" /> {/* Watch icon */}
                            <div>
                                <h5 className='mb-1 text-xl'>{trans('Saturday')}</h5>
                                <p className='mb-1 text-xl'>{trans('07:00 PM - 11:00 PM')}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h4 className='mb-6 text-3xl font-bold'>{trans('Call Us')}</h4>
                        <div className="flex items-center">
                            <FaPhoneAlt size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="tel:035-505-448" className="text-blue-300 text-xl">{trans('035-505-448')}</a>
                        </div>
                        <div className="flex items-center mt-4">
                            <FaPhoneAlt size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="tel:052-686-6442" className="text-blue-300 text-xl">{trans('052-686-6442')}</a>
                        </div>
                    </div>
                    <div>
                        <h4 className='mb-6 text-3xl font-bold'>{trans('Write Us Message')}</h4>
                        <div className="flex items-center">
                            <FaEnvelope size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="mailto:perfect.smile.israel@gmail.com" className="text-blue-300 text-xl">perfect.smile.israel@gmail.com</a>
                        </div>
                    </div>
                    <div>
                        <h4 className='mb-6 text-3xl font-bold'>{trans('Our Address')}</h4>
                        <div className="flex items-center">
                            <FaMapMarkerAlt size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="https://www.google.com/maps/search/Street+Hazetem+96++Giv'at+Shmuel++Building+Aor+Bagbaa" target='_blank' className={'underline text-blue-300 text-xl'}>
                                <p className='mb-1'>{trans('Street Hazetem 96')}</p>
                                <p className='mb-1'>{trans('Giv\'at Shmuel')}</p>
                                <p className='mb-1'>{trans('Building Aor Bagbaa')}</p>
                            </a>
                        </div>
                        <hr className={'w-full h-0.5 bg-white my-4'}/>
                        <div className="flex items-center">
                            <FaMapMarkerAlt size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="https://www.google.com/maps/search/Street+Haatsmaaot+6++Kryat+Ata" target='_blank' className={'underline text-blue-300 text-xl'}>
                                <p className='mb-1'>{trans('Street Haatsmaaot 6')}</p>
                                <p className='mb-1'>{trans('Kryat Ata')}</p>
                            </a>
                        </div>
                        <hr className={'w-full h-0.5 bg-white my-4'}/>
                        <div className="flex items-center">
                            <FaMapMarkerAlt size={32} color="white" className="me-4" /> {/* Set color to white */}
                            <a href="https://www.google.com/maps/search/Street+Shamalle+1++Tamra" target='_blank' className={'underline text-blue-300 text-xl'}>
                                <p className='mb-1'>{trans('Street Shamalle 1')}</p>
                                <p className='mb-1'>{trans('Tamra')}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div id='footer-bottom' className="mt-8">
                <p className="text-center text-lg">{trans('All Rights Reserved')} — © {trans('Copyright PerfectSmile')} 2023</p>
            </div>
            <div className="flex justify-center mt-8">
                <a href="https://wa.me/+972526866442" target="_blank">
                    <ImWhatsapp size={40} className='whatsappICON' color="white" />
                </a>
            </div>
        </footer>
    )
}

export default Footer;
